<template>
  <b-modal @hide="modalClose" ref="storageModal" :title="$t('保管場所')" size="xl">
    <b-container fluid>
      <table v-for="(item, index) in deleteHide" :key="index" class="table border-0 table-bordered my-3">
        <thead class="thead border-0">
          <tr class="border-0">
            <th class="border-0 text-left" colspan="99">{{ $t('在庫情報') }}{{ index + 1 }}</th>
          </tr>
        </thead>
        <tbody class="tbody">
          <tr>
            <th class="table-active text-left" width="180">{{ $t('在庫区分') }}</th>
            <td class="text-left" width="180">
              <select v-model.number="item.inventoryKindId" class="form-control" id="">
                <option :value="null">-</option>
                <template v-for="(inventoryKindItem, inventoryKindIndex) in inventoryKinds">
                  <option :key="`inventoryKind-${inventoryKindIndex}`" :value="inventoryKindItem.id">{{ inventoryKindItem.name }}</option>
                </template>
              </select>
            </td>
            <th class="table-active text-left" width="180">{{ $t('工場') }}</th>
            <td class="text-left" width="180">
              <select v-model.number="item.site" @focus="uniqueCombination(item,index,'dep','site')" @blur="disabledClear(`site${index}`)" class="form-control" :id="`site${index}`">
                <option :value="null">-</option>
                <template v-for="(siteItem, siteIndex) in site">
                  <option :key="`site-${siteIndex}`" :value="siteItem.id">{{ siteItem.name }}</option>
                </template>
              </select>
            </td>
            <th class="table-active text-left" width="180">{{ $t('部署') }}</th>
            <td class="text-left" width="180">
              <select v-model.number="item.dep" @focus="uniqueCombination(item,index,'site','dep')" @blur="disabledClear(`dep${index}`)" class="form-control" :id="`dep${index}`">
                <option :value="null">-</option>
                <template v-for="(depItem, depIndex) in dep">
                  <option :key="`dep-${depIndex}`" :value="depItem.id">{{ depItem.name }}</option>
                </template>
              </select>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('置き場') }}</th>
            <td class="text-left">
              <select v-model.number="item.place" multiple class="form-control form-scroll" id="">
                <template v-for="(placeItem, placeIndex) in place">
                  <option :key="`place-${placeIndex}`" :value="placeItem.id">{{ placeItem.name }}</option>
                </template>
              </select>
            </td>
            <th class="table-active text-left">{{ $t('棚番') }}</th>
            <td class="text-left">
              <select v-model.number="item.box" multiple class="form-control form-scroll" id="">
                <template v-for="(boxItem, boxIndex) in box">
                  <option :key="`box-${boxIndex}`" :value="boxItem.id">{{ boxItem.name }}</option>
                </template>
              </select>
            </td>
            <th class="table-active text-left">{{ $t('保管期間') }}</th>
            <td class="text-left">
              <div class="form-group">
                <div class="w-100">
                  <div class="input-group" id="regular_end_time" data-widget="timepicker">
                    <input v-model.number="item.period" type="number" class="form-control">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        {{ $t('日') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('標準在庫数') }}<span class="text-danger"><br>{{ $t("※必須") }}</span></th>
            <td>
              <input
                v-model.number="item.baseQuantity"
                type="number"
                class="form-control"
                :class="{ 'is-invalid': errors[index].baseQuantity }"
                min="0"
              >
              <div v-if="errors[index].baseQuantity" class="invalid-feedback">
                {{ $t(errors[index].baseQuantity) }}
              </div>
            </td>
            <th class="table-active text-left">{{ $t('手配単位サイズ') }}<span class="text-danger"><br>{{ $t("※必須") }}</span></th>
            <td>
              <input
                v-model.number="item.supplyLotSize"
                type="number"
                class="form-control"
                :class="{ 'is-invalid': errors[index].supplyLotSize }"
                min="0"
              >
              <div v-if="errors[index].supplyLotSize" class="invalid-feedback">
                {{ $t(errors[index].supplyLotSize) }}
              </div>
            </td>
            <th class="table-active text-left">{{ $t('手配リードタイム') }}<span class="text-danger"><br>{{ $t("※必須") }}</span></th>
            <td class="text-left">
              <div class="form-group">
                <div class="w-100">
                  <div class="input-group" id="regular_end_time" data-widget="timepicker">
                    <input
                      v-model.number="item.supplyLeadTime"
                      type="number"
                      class="form-control"
                      :class="{ 'is-invalid': errors[index].supplyLeadTime }"
                      min="0"
                    >
                    <div class="input-group-append">
                      <span class="input-group-text">
                        {{ $t('日') }}
                      </span>
                    </div>
                    <div v-if="errors[index].supplyLeadTime" class="invalid-feedback">
                      {{ $t(errors[index].supplyLeadTime) }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('保管場所備考') }}</th>
            <td colspan="4">
              <input v-model="item.note" type="text" class="form-control">
            </td>
            <td>
              <button
                type="button"
                class="btn btn-danger create-btn"
                @click="addDeleteFlag(item)"
              >
                {{ $t('削除') }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <b-row>
        <b-col class="form-group">
          <button
            type="button"
            class="btn btn-light mb-3"
            :disabled="registering"
            @click="addInventory()"
          >
            <div
              class="d-flex justify-content-center align-items-center mr-3"
              v-if="registering"
            >
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </div>
            {{ $t('保管場所追加') }}
          </button>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-footer>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>

        <button
          type="button"
          class="btn btn-success mb-3 d-flex align-items-center justify-content-center mr-3"
          :disabled="registering"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
const errorFieldRequired = 'field required'
const errorTargetGE = '{{target}}は{{value}}以上の数字を入力して下さい'
const errorTargetGT = '{{target}}は{{value}}より大きい数字を入力して下さい'

const initFormat = {
  site: null,
  dep: null,
  place: [],
  box: [],
  inventoryKindId: null,
  baseQuantity: 0,
  period: null,
  supplyLotSize: 1,
  supplyLeadTime: 5,
  id: null,
  productId: null,
  note: '',
  isDelete: false,
}

const defaultErrors = {baseQuantity: '', supplyLotSize: '', supplyLeadTime: ''}

export default {
  props: {
    productId: {
      type: Number,
    },
    inventories: {
      type: Array,
    },
    inventoryKinds: {
      type: Array,
    },
    spaces: {
      type: Array,
    },
  },
  data() {
    return {
      form: [],
      errors: [],
      registering: false,
    }
  },
  methods: {
    // モーダルを開いたときの処理
    async modalOpen() {
      // this.form = []
      for (let i = 0;i < this.inventories.length;i++) {
        this.form.push(this.mixin_deepcopy(initFormat))
        this.errors.push(this.mixin_deepcopy(defaultErrors))
      }
      this.inventories.map((item, index) => {
        for (let key of Object.keys(item)) {
          if (key === 'spaces') {
            for (let space in Object.keys(item.spaces)) {
              if (item.spaces[space]) this.form[index][space] = item.spaces[space]
            }
          } else {
            if (item[key]) this.form[index][key] = item[key]
          }
        }
      })
      if (this.form.length === 0) this.addInventory()
      this.$refs.storageModal.show()
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.form = []
      this.$emit('modalClose')
      this.$refs.storageModal.hide()
    },
    // 工場と部署の組み合わせが同じものを選択させないように項目をdisabledにする処理
    uniqueCombination(item, index, target, key) {
      const filter = this.form.filter((inventoryItem, inventoryIndex) => {
        if (inventoryItem[target] === item[target] && inventoryIndex !== index) return true
      })
      if (filter.length === 0) return
      let ids = []
      for (let i = 0; i < filter.length; i++) {
        ids.push(filter[i][key])
      }
      if (ids.length === 0) return

      let select = document.getElementById(`${key}${index}`)
      let options = Array.from(select.children)
      options.map(option => {
        ids.map(spaceId => {
          if (option.value == spaceId && option.value !== -1 && spaceId !== -1) {
            option.setAttribute('disabled', true)
          }
        })
      })
    },
    addDeleteFlag(item) {
      this.$set(item, 'isDelete', true)
    },
    // disabledにした項目を初期化する処理
    disabledClear(id) {
      let select = document.getElementById(id)
      let options = Array.from(select.children)
      options.map(option => {
        option.removeAttribute('disabled')
      })
    },
    // 保管場所追加処理
    addInventory() {
      this.form.push(this.mixin_deepcopy(initFormat))
      this.errors.push(this.mixin_deepcopy(defaultErrors))
    },
    deleteInventoryApi(params) {
      return this.$axios({
        method: 'delete',
        headers: {
          Authorization: this.authorization ? this.authorization : null,
        },
        url: `${this.$appConfig.CommonApiUrl}/inventory`,
        params: params,
      })
    },
    postInventoryApi(params) {
      return this.$axios({
        method: 'post',
        headers: {
          Authorization: this.authorization ? this.authorization : null,
        },
        url: `${this.$appConfig.CommonApiUrl}/inventory`,
        data: params,
      })
    },
    putInventoryApi(params) {
      return this.$axios({
        method: 'put',
        headers: {
          Authorization: this.authorization ? this.authorization : null,
        },
        url: `${this.$appConfig.CommonApiUrl}/inventory`,
        data: params,
      })
    },
    commonValidate(params) {
      let hasError = false
      const errors = this.mixin_deepcopy(defaultErrors)
      if (this.isEmpty(params.baseQuantity) && !params.isDelete) {
        errors.baseQuantity = this.$t(errorFieldRequired)
        hasError = true
      } else if (params.baseQuantity < 0 && !params.isDelete) {
        errors.baseQuantity = this.$t(errorTargetGE)
          .replace('{{target}}', this.$t('baseQuantity'))
          .replace('{{value}}', 0)
        hasError = true
      }
      if (this.isEmpty(params.supplyLotSize) && !params.isDelete) {
        errors.supplyLotSize = this.$t(errorFieldRequired)
        hasError = true
      } else if (params.supplyLotSize <= 0 && !params.isDelete) {
        errors.supplyLotSize = this.$t(errorTargetGT)
          .replace('{{target}}', this.$t('supplyLotSize'))
          .replace('{{value}}', 0)
        hasError = true
      }
      if (this.isEmpty(params.supplyLeadTime) && !params.isDelete) {
        errors.supplyLeadTime = this.$t(errorFieldRequired)
      } else if (params.supplyLeadTime <= 0 && !params.isDelete) {
        errors.supplyLeadTime = this.$t(errorTargetGT)
          .replace('{{target}}', this.$t('supplyLeadTime'))
          .replace('{{value}}', 0)
      }
      return {errors, hasError}
    },
    async register() {
      if (this.form.length === 0) return
      const errors = []
      let hasError = false
      for (let i = 0;i < this.form.length;i++) {
        const result = this.commonValidate(this.form[i])

        errors.push(result.errors)
        hasError = hasError || result.hasError
      }
      this.errors = errors
      if (hasError) return

      this.registering = true
      for (let i = 0;i < this.form.length;i++) {
        if (!this.form[i].id && this.form[i].isDelete) continue
        const params = {
          id: this.form[i].id,
          productId: this.productId,
          site: this.form[i].site,
          dep: this.form[i].dep,
          place: this.form[i].place || [],
          box: this.form[i].box || [],
          inventoryKindId: this.form[i].inventoryKindId,
          baseQuantity: this.form[i].baseQuantity,
          period: this.form[i].period,
          supplyLotSize: this.form[i].supplyLotSize,
          supplyLeadTime: this.form[i].supplyLeadTime,
          note: this.form[i].note || '',
          isDelete: this.form[i].isDelete || false,
        }
        if (params.id) {
          if (params.isDelete) {
            await this.deleteInventoryApi(params)
          } else {
            await this.putInventoryApi(params)
          }
        } else {
            await this.postInventoryApi(params)
        }
      }
      if (this.registering) {
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.registering = false
        this.form = []
        this.$emit('registered')
        this.$refs.storageModal.hide()
      } else {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
    },
  },
  computed: {
    deleteHide() {
      return this.form.filter(item => !item.isDelete)
    },
    site() {
      return this.spaces.filter(item => item.key === 'site')
    },
    dep() {
      return this.spaces.filter(item => item.key === 'dep')
    },
    place() {
      return this.spaces.filter(item => item.key === 'place')
    },
    box() {
      return this.spaces.filter(item => item.key === 'box')
    },
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
.form-scroll {
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
